var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("color: " + _vm.color)),attrs:{"id":"AlertMessage"}},[_c('span',{staticClass:"material-symbols-outlined"},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('div',[_vm._v(" "+_vm._s(_vm.message)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }